import { FC } from "react";
import { ActionIcon, Group, Stack } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useMutation } from "@tanstack/react-query";
import { gameRevokeTimePenalty } from "../../../../openapi/api-client";
import { TimePenaltyButton } from "./TimePenaltyButton";
import { TimePenaltyCountdown } from "./TimePenaltyCountdown";
import { components } from "../../../../openapi/generated-types";

type TimePenalty = components["schemas"]["TimePenalty"];

interface TimePenaltiesPanelProps {
  teamId: string | null;
  gameId: string;
  time: number;
  timePenalties: TimePenalty[];
  disabled: boolean;
}

export const TimePenaltiesPanel: FC<TimePenaltiesPanelProps> = ({
  teamId,
  gameId,
  time,
  timePenalties,
  disabled,
}) => {
  const revokeTimePenaltyMutation = useMutation({
    mutationFn: gameRevokeTimePenalty,
  });

  const activeTimePenalties = timePenalties
    .filter((tp) => tp.teamId === teamId)
    .filter((tp) => tp.time - tp.duration < time)
    .filter((tp) => !tp.finishedByGoalId);

  return (
    <Stack>
      <TimePenaltyButton
        teamId={teamId}
        gameId={gameId}
        time={time}
        disabled={disabled}
      />
      {activeTimePenalties.map((tp) => (
        <Group key={tp.timePenaltyId} gap="xs">
          <TimePenaltyCountdown time={time} timePenalty={tp} />
          <ActionIcon
            size="xs"
            variant="subtle"
            color="red"
            onClick={() =>
              void revokeTimePenaltyMutation.mutateAsync({
                id: gameId,
                timePenaltyId: tp.timePenaltyId,
              })
            }
          >
            <IconX size={12} />
          </ActionIcon>
        </Group>
      ))}
    </Stack>
  );
};
